'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markMessage = exports.getMessage = exports.getMessagesWithStatus = exports.getMessages = undefined;

var _utils = require('./utils');

var getMessages = exports.getMessages = function getMessages(playerSessionID) {
  return (0, _utils.getProtected)('/internalmessages', playerSessionID);
};

var getMessagesWithStatus = exports.getMessagesWithStatus = function getMessagesWithStatus(playerSessionID, status) {
  return (0, _utils.getProtected)('/internalmessages/with-status?status=' + status, playerSessionID);
};

var getMessage = exports.getMessage = function getMessage(playerSessionID, messageID) {
  return (0, _utils.getProtected)('/internalmessages/' + messageID, playerSessionID);
};

var markMessage = exports.markMessage = function markMessage(playerSessionId, data) {
  return (0, _utils.postProtected)('/internalmessages/mark', playerSessionId, data);
};

exports.default = {
  getMessages: getMessages,
  getMessagesWithStatus: getMessagesWithStatus,
  getMessage: getMessage,
  markMessage: markMessage
};